import { render, staticRenderFns } from "./Copyright.vue?vue&type=template&id=f777488a&scoped=true"
import script from "./Copyright.vue?vue&type=script&lang=js"
export * from "./Copyright.vue?vue&type=script&lang=js"
import style0 from "./Copyright.vue?vue&type=style&index=0&id=f777488a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f777488a",
  null
  
)

export default component.exports